export const OFFERS_VIEW_PATH: string = "/of";
export const CREATE_OFFER_VIEW_PATH: string = "/of/create";
export const OFFER_DETAIL_VIEW_PATH: string = "/of/:offerUUID";
export const EDIT_OFFER_VIEW_PATH: string = "/of/:offerUUID/edit";
